import { useEffect, useState } from "react";

/**
 * Returns a debounced copy of `value` that only updates `delay` ms after the
 * last change. Used to keep server-side searches from firing a request on
 * every keystroke.
 */
export function useDebouncedValue<T>(value: T, delay = 400): T {
  const [debounced, setDebounced] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebounced(value);
    }, delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
